import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "tooltip",
  "data-tip": "Configuration modified, click to reset"
}

import { useBackendStore } from "@/stores";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigModifiedIndicator',
  setup(__props) {

const backend = useBackendStore();

const resetConfig = () => {
  if (backend.currentConfig != null)
    backend.setCurrentConfig(backend.currentConfig.id);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (_unref(backend).configModified)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "cursor-pointer",
            onClick: resetConfig
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Icon, {
                icon: "mi:undo",
                class: "hover:scale-110"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})